export default __webpack_public_path__ + "static/media/Google.2e25cd19.svg";